
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M21.9995 5c0-2.76142 2.2386-5 5-5 2.7615 0 5 2.23858 5 5s-2.2385 5-5 5c-2.7614 0-5-2.23858-5-5zm5-3c-1.6568 0-3 1.34315-3 3s1.3432 3 3 3c1.6569 0 3-1.34315 3-3s-1.3431-3-3-3z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"currentColor","d":"M9.34569 19.6621c-.22333.2233-.34615.5205-.34615.8357 0 .3101.11853.6013.33412.8229l5.32204-5.322-5.32204-5.322c-.44836.4621-.44407 1.2025.01203 1.6595l3.66251 3.6625-3.66251 3.6634zM21.3207 9.3331c-.4621-.44837-1.2026-.44407-1.6595.01289l-3.6626 3.66251-3.6625-3.66251c-.457-.45696-1.1974-.46126-1.6595-.01289l5.322 5.322 5.3221-5.322zM12.337 22.6537l3.6616-3.6625 3.6626 3.6625c.2233.2233.5205.3462.8357.3462.3101 0 .6013-.1186.8238-.3342l-5.3221-5.322-5.322 5.322c.2216.2156.5137.3342.8237.3342.3161 0 .6133-.1229.8367-.3462zM22.9992 20.4987c0-.3161-.1228-.6124-.3461-.8358l-3.6626-3.6625 3.6626-3.6625c.4569-.457.4612-1.1974.012-1.6595l-5.3212 5.322 5.3212 5.322c.2156-.2224.3341-.5145.3341-.8237z"}}),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M6.1005 6.10051C.633165 11.5678.633165 20.4322 6.1005 25.8995c5.4673 5.4673 14.3317 5.4673 19.799 0 2.0187-2.0187 3.2908-4.4978 3.8191-7.0986.11-.5412.6379-.8908 1.1791-.7809.5412.11.8908.6378.7809 1.1791-.6041 2.9738-2.06 5.8097-4.3649 8.1146-6.2484 6.2484-16.379 6.2484-22.62741 0-6.24839-6.2484-6.24839-16.379 0-22.62741C9.77135-.398768 17.4254-1.34431 23.4665 1.84446c.4884.25781.6754.86275.4175 1.35117-.2578.48842-.8627.67536-1.3511.41755C17.2454.822231 10.5479 1.65307 6.1005 6.10051z","clip-rule":"evenodd"}})])
          )
        }
      }
    